import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App/App';

// Ant Design
import { ConfigProvider } from 'antd';
import theme from './theme/theme.json';

// Redux
import store from './store';
import { Provider } from 'react-redux';

// Suppress cross-origin "Script error." overlay in development (e.g. from Adblocker/Iframes)
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('error', (event) => {
    if (event.message === 'Script error.' || event.message === 'Script error') {
      event.stopImmediatePropagation();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ConfigProvider theme={theme}>
    <Provider store={store}>
      <App />
    </Provider>
  </ConfigProvider>
);